import { PostLoginActionNameEnum } from '@sparkware/uc-sdk-core';
import { Service } from 'typedi';
import { IPostLoginAction } from '../models/IPostLoginAction';
import { IPostLoginActionsState } from '../models/IPostLoginActionsState';
import { CheckForPendingIdentityVerificationPostLoginAction } from './check-for-pending-indentity-verification-post-login-action';
import { GetPersonalLimitsPostLoginAction } from './get-personal-limits-post-login-action';
import { InitGeolocationFlowPostLoginAction } from './init-geolocation-flow-post-login-action';
import { OpenAccountSummaryPostLoginAction } from './open-account-summary-post-login-action';
import { OpenActivityHistoryPostLoginAction } from './open-activity-history-post-login-action';
import { OpenCashierPostLoginAction } from './open-cashier-post-login-action';
import { OpenCashierUploadDocumentsPostLoginAction } from './open-cashier-upload-documents-post-login-action';
import { OpenKYCPostLoginAction } from './open-kyc-post-login-action';
import { OpenLoginNotificationPostLoginAction } from './open-login-notification-post-login-action';
import { OpenOnlineMessagesPostLoginAction } from './open-online-messages-post-login-action';
import { ShowPlayerWinLossPostLoginAction } from './show-player-win-loss-post-login-action';
import { StartFavouriteSportsFlowPostLoginAction } from './start-favourite-sports-flow-post-login-action';
import { UploadDocumentsPostLoginAction } from './upload-documents-post-login-action';
import { OpenControlCenterPostLoginAction } from './open-control-center-post-login-action';
import { ForceBrandPostLoginAction } from './force-brand-post-login-action';
import { ShowOnboardingPostLoginAction } from './show-onboarding-post-login-action';

@Service()
export class PostLoginActionFactory {
    constructor() {}

    public create(
        actionName: PostLoginActionNameEnum,
        state: IPostLoginActionsState,
    ): IPostLoginAction {
        let returnedAction: IPostLoginAction = null;

        switch (actionName) {
            case PostLoginActionNameEnum.OpenCashier: {
                returnedAction = new OpenCashierPostLoginAction(state);
                break;
            }
            case PostLoginActionNameEnum.ActivityHistory: {
                returnedAction = new OpenActivityHistoryPostLoginAction(state);
                break;
            }
            case PostLoginActionNameEnum.CheckForPendingIdentityVerification: {
                returnedAction = new CheckForPendingIdentityVerificationPostLoginAction(state);
                break;
            }
            case PostLoginActionNameEnum.CheckIfLoginNotificationRequired: {
                returnedAction = new OpenLoginNotificationPostLoginAction(state);
                break;
            }
            case PostLoginActionNameEnum.GetPersonalLimits: {
                returnedAction = new GetPersonalLimitsPostLoginAction(state);
                break;
            }
            case PostLoginActionNameEnum.InitGeolocationFlow: {
                returnedAction = new InitGeolocationFlowPostLoginAction(state);
                break;
            }
            case PostLoginActionNameEnum.OMGGetWaitingMessages: {
                returnedAction = new OpenOnlineMessagesPostLoginAction(state);
                break;
            }
            case PostLoginActionNameEnum.OpenCashierUploadDocument: {
                returnedAction = new OpenCashierUploadDocumentsPostLoginAction(state);
                break;
            }
            case PostLoginActionNameEnum.ShowAccountSummaryPage: {
                returnedAction = new OpenAccountSummaryPostLoginAction(state);
                break;
            }

            case PostLoginActionNameEnum.ShowKYC: {
                returnedAction = new OpenKYCPostLoginAction(state);
                break;
            }

            case PostLoginActionNameEnum.StartFavouriteSportsFlow: {
                returnedAction = new StartFavouriteSportsFlowPostLoginAction(state);
                break;
            }

            case PostLoginActionNameEnum.UploadDocuments: {
                returnedAction = new UploadDocumentsPostLoginAction(state);
                break;
            }

            case PostLoginActionNameEnum.ShowPlayerWinLoss: {
                returnedAction = new ShowPlayerWinLossPostLoginAction(state);
                break;
            }

            case PostLoginActionNameEnum.OpenControlCenterFull: {
                returnedAction = new OpenControlCenterPostLoginAction(state);
                break;
            }

            case PostLoginActionNameEnum.ForceBrand: {
                returnedAction = new ForceBrandPostLoginAction(state);
                break;
            }

            case PostLoginActionNameEnum.ShowOnboarding: {
                returnedAction = new ShowOnboardingPostLoginAction(state);
                break;
            }

            default: {
                throw new Error(`Action with name ${actionName} does not exist.`);
            }
        }

        return returnedAction;
    }
}
